
import { defineComponent } from 'vue';
import { conteudoSite, Avaliacao } from '@/uteis/conteudo';

export default defineComponent({
    name: 'AvaliacoesGoogle',
    computed: {
        // Avaliações do perfil da LimaTec no Google — editáveis pelo painel
        avaliacoes(): Avaliacao[] {
            return conteudoSite.avaliacoes;
        }
    }
});
